export default __webpack_public_path__ + "static/media/file-upload.a29c1ca8.svg";